import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    PRIMARY_LIST_START: 'PRIMARY_LIST_START',
    PRIMARY_LIST_SUCCESS: 'PRIMARY_LIST_SUCCESS',
    PRIMARY_LIST_FAILED: 'PRIMARY_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const primaryListStart = (data) => ({
   type: actionType.PRIMARY_LIST_START,
   payload: data
})

export const primaryListSuccess = (data) => ({
    type: actionType.PRIMARY_LIST_SUCCESS,
    payload: data
})

export const primaryListFailed = (data) => ({
    type: actionType.PRIMARY_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function primaryListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.PRIMARY_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.PRIMARY_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.PRIMARY_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* primaryListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allPrimaryPosition = response.data.data.allPrimarypositions.Primarypositions ? response.data.data.allPrimarypositions.Primarypositions : null
       yield put(primaryListSuccess(allPrimaryPosition));
    } else {
      messagePopup('','PRIMARY List failed','error')   
      yield put(primaryListFailed('PRIMARY List failed')) 
    }
   } catch (error) {
     messagePopup('','PRIMARY List failed','error')   
     yield put(primaryListFailed('PRIMARY List failed')) 
   }
}

export function* watchPrimaryListSaga(){
    yield takeEvery(actionType.PRIMARY_LIST_START, primaryListSaga)
}